import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/storage';

import googleMapsClient from '@google/maps';

export const MAPS_API_KEY = 'AIzaSyC6ey4TaIdrfOqMmhEuIAy3imrxiMKNHS4';
export const maps = googleMapsClient.createClient({
  key: MAPS_API_KEY,
  Promise: Promise,
});

// Initialize Firebase
var config = {
  apiKey: 'AIzaSyBGIDw9eYxRL6wf6ZeYqWUINPEHZFb4ZI4',
  authDomain: 'dpcmapper.firebaseapp.com',
  databaseURL: 'https://dpcmapper.firebaseio.com',
  projectId: 'dpcmapper',
  storageBucket: 'dpcmapper.appspot.com',
  messagingSenderId: '181723444131',
};

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}
// firebase.initializeApp(config);

const isLocal =
  typeof window !== 'undefined' &&
  window !== undefined &&
  window.location !== undefined &&
  window.location.href.includes('localhost');

console.log('IS LOCAL: ' + isLocal);

export { firebase };
export const db = firebase.database().ref();
// db.settings({ timestampsInSnapshots: true });
export const auth = firebase.auth();

export const serverURL = isLocal
  ? 'http://localhost:5000/api/'
  : 'https://api.dpcfrontier.com/';

export const mapperURL = isLocal
  ? 'http://localhost:3000/'
  : 'https://mapper.dpcfrontier.com/';

export const dashURL = isLocal
  ? 'http://localhost:4000/'
  : 'https://dashboard.dpcfrontier.com/';
